// 引入main文件夹中或路由文件所有的路由
import enterpriseRoutes from '@/router/main/enterprise' // 企业管理路由
import expertRoutes from '@/router/main/expert' // 专家管理路由
import financialRoutes from '@/router/main/financial' // 财务管理路由
import guaranteeRoutes from '@/router/main/guarantee' // 保证金预存路由
import serviceRoutes from '@/router/main/services' // 会员、CA中心路由
import signatureRoutes from '@/router/main/signature' // 在线签章路由

export default [
  enterpriseRoutes,
  expertRoutes,
  financialRoutes,
  guaranteeRoutes,
  serviceRoutes,
  signatureRoutes
]
